// extracted by mini-css-extract-plugin
module.exports = {"sized":"icon_sized__E3nuN","textAligned":"icon_textAligned__BGqHI"};